<template>
  <div
    class="cooperation-page__files-drag-drop"
    :class="{ isDragOver, readonly }"
    @drop.prevent="!readonly && onDraggedFile($event)"
    @dragover.prevent="!readonly && (isDragOver = true)"
    @dragleave.prevent="!readonly && (isDragOver = false)"
  >
    <input
      ref="fileInput"
      class="d-none"
      type="file"
      multiple
      @change="onChangedFiles()"
    >

    <button
      class="cooperation-page__files-drag-drop-icon base-btn"
      :class="{
        'base-btn--green': !isEmployer,
        'base-btn--blue': isEmployer
      }"
      :disabled="readonly"
      @click="!readonly && $refs.fileInput.click()"
    >
      <BaseSvg name="ico-plus"/>
      <span class="base-btn__text">{{$tCooperation('Add')}}</span>
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      readonly: {
        type: Boolean
      },
      isEmployer: {
        type: Boolean
      }
    },

    data() {
      return {
        isDragOver: false
      };
    },

    methods: {
      onChangedFiles() {
        this.$refs.fileInput.files.forEach((file) => this.addFile(file));
      },

      onDraggedFile(e) {
        if (this.readonly) return;

        this.isDragOver = false;
        ((e.dataTransfer || {}).files || []).forEach((file) => this.addFile(file));
      },

      addFile(file) {
        const data = {
          file,
          name: file.name,
          size: file.size,
          ext: file.type.split('/').reverse()[ 0 ]
        };

        this.$emit('add', data);
      }
    }
  };
</script>
